import { memo } from "react";
import { bool, number, string, oneOfType, node } from "prop-types";
import { ValueDivider } from "@components";
import { NumericFormat } from "react-number-format";

export const ValueCellReadOnlyContent = memo(({
  value,
  valueMax,
  displayMax,
  emptyInputs,
  symbolStart,
  symbolEnd,
  showDecimals,
  americanFormat,
  applySuffixSpacing,
  displayMinMaxSeparator = true,
  allowNegative=false,
  decimals=2,
}) => {
  const formatterProps = {
    allowNegative,
    // fixedDecimalScale: showDecimals,
    decimalScale: showDecimals ? decimals : 0,
    prefix: symbolStart,
    suffix: applySuffixSpacing && symbolEnd ? ` ${symbolEnd.trim()}` : symbolEnd,
    thousandSeparator: americanFormat ? "," : " ",
    decimalSeparator: ".",
    allowedDecimalSeparators: [",", "."],
    valueIsNumericString: !isNaN(Number(value)),
    displayType: "text",
    className: "w-full",
  };
  
  const isValueText = value !== undefined && isNaN(Number(value)) && value !== null;
  const isValueMaxText = value !== undefined && isNaN(Number(valueMax)) && value !== null;

  return (
    <>
      {
        !emptyInputs && (
          isValueText
            ? <span
              className="w-full"
              style={{ textAlign: displayMax ? "right" : "center" }}
            >
              {formatterProps.prefix}
              {value}
              {formatterProps.suffix}
            </span>
            : <NumericFormat
              value={typeof value === "undefined" ? "" : value}
              style={{ textAlign: displayMax ? "right" : "center" }}
              {...formatterProps}
            />
        )
      }
      { displayMax && !emptyInputs && <ValueDivider display={displayMinMaxSeparator} /> }
      { displayMax && !emptyInputs && (
        isValueMaxText
          ? <span className="w-full" style={{ textAlign: "left" }}>
            {formatterProps.prefix}
            {valueMax}
            {formatterProps.suffix}
          </span>
          : <NumericFormat
            value={typeof valueMax === "undefined" ? "" : valueMax}
            style={{ textAlign: "left" }}
            {...formatterProps}
          />
      )}
    </>
  )
});

ValueCellReadOnlyContent.propTypes = {
  value: oneOfType([number, string]),
  valueMax: oneOfType([number, string]),
  displayMax: bool,
  displayMinMaxSeparator: bool,
  symbolStart: string,
  symbolEnd: oneOfType([node, string]),
  // parser: func,
  allowNegative: bool,
  americanFormat: bool,
  applySuffixSpacing: bool,
  showDecimals: bool,
  emptyInputs: bool,
  decimals: number,
};